import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import { IControlProps, MapProps } from '.';
import { Alert } from '..';
import Translate from '../../core/translate';
import { IFileContent } from '../../services/api/services/model';
import { Button, InputText } from '../prime';
import styles from './index.module.scss';

interface IProps extends IControlProps<IFileContent | undefined> { 
  storage?: IDataStorage;
  /** tipo de archivo permitido */
  accept?: string;


  hideDelete?: boolean;

  /** tamaño maximo del archivo en kb */
  maxSize?: number;
}

interface IState extends IControlProps<IFileContent | undefined> {
  storage?: IDataStorage;
  /** Indica el mensaje de error si es que existe */
  validError?: string;

  hideDelete?: boolean;

  accept?: string;
  maxSize?: number;
}

class Index extends React.Component<IProps, IState> {
  state: IState = {};
  uk : string = `usf_${parseInt(`${Math.random() * 100000}`)}`;
  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    if (this.props?.form && this.props?.name) this.props.form.add(this, this.props.name, () => this.change(this.state.value));
  }
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.accept !== s?.accept) res.accept = p?.accept;
    if (p?.maxSize !== s?.maxSize) res.maxSize = p?.maxSize;
    if (p?.hideDelete !== s?.hideDelete) res.hideDelete = p?.hideDelete;
    return MapProps<IFileContent | undefined>(res, p, s);
  }

  render() {
    const { validError } = this.state;
    const t = Translate.get("component/uploadsinglefile", this.state.storage?.languaje);
    
    return (
      <div className={`form-group ${this.state.className ?? ''}`} style={this.state.style}>
        {this.state.title && <label className={(validError && styles.errortitle) ?? ''}>{this.state.title}</label>}
        <div className={`${styles.addons} p-inputgroup`}>
          {this.state.required && 
            <span className={`p-inputgroup-addon ${(validError && styles.erroraddon) ?? ''}`}>
              <i className="pi pi-exclamation-circle" />
            </span>
          }
          <InputText 
            value={this.state.value?.nombre ?? this.state.placeholder ?? t("Empty")}
            readOnly
            tooltip={validError}
            tooltipOptions={{ position: 'bottom' }}
          />
          {!this.state.disabled &&
            <Button 
              icon={'pi pi-cloud-upload'}
              className="p-button-primary" 
              disabled={this.state.disabled}
              onClick={() => { $(`#${this.uk}`).click(); }} 
              tooltip={t("Btn.Upload")} 
              tooltipOptions={{position:'top'}} 
            />
          }
          {this.state.value &&
            <Button 
              icon={'fas fa-download'}
              className="p-button-success" 
              onClick={() => { 
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = this.state.value?.content ?? this.state.value?.url ?? '#';
                // the filename you want
                a.download = this.state.value?.nombre ?? '';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(a.href);
              }} 
              tooltip={t("Btn.Download")} 
              tooltipOptions={{position:'top'}} 
            />
          }
          {this.state.value && !this.state.disabled && !this.state.hideDelete &&
            <Button 
              icon={'pi pi-times'}
              className="p-button-danger" 
              onClick={() => {
                $(`#${this.uk}`).val('');
                this.change(undefined);
              }} 
              tooltip={t("Btn.Clear")} 
              tooltipOptions={{position:'top'}} 
            />
          }
        </div>
        {validError && <span className={styles.errordesc}>{validError}</span>}
        <input id={`${this.uk}`} type="file" style={{ opacity: 0, display: 'none' }} accept={this.state.accept} onChange={(e:any) => this.fileselected(e.target)}/>
      </div>
    );
  }

  fileselected = (ctrl: any) => {
    const t = Translate.get("component/uploadsinglefile", this.state.storage?.languaje);
    var reader = new FileReader();
    if (ctrl.files && ctrl.files[0]) {
      if (this.state.maxSize && (ctrl.files[0].size / 1024) > this.state.maxSize)
      {
        Alert.error(t('MaxFileSize.Title'), t('MaxFileSize.Message', { filesize: Math.floor(ctrl.files[0].size / 1024), maxsize: this.state.maxSize }));
        $(`#${this.uk}`).val('');
        return;
      }

      reader.onload = (e:any) => {
        console.log("file-selected", e)
        const value = {
          nombre: ctrl.files[0].name,
          content: e.target.result
        };
        this.change(value);
      };
      reader.readAsDataURL(ctrl.files[0]);
    }
  }

  
  change = (value?: IFileContent) : string | undefined => {
    const { onChange } = this.props;

    if (onChange) onChange(value, undefined);

    return undefined;
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
